import { render, staticRenderFns } from "./MapLegend.vue?vue&type=template&id=f18754d6&"
import script from "./MapLegend.vue?vue&type=script&lang=js&"
export * from "./MapLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports